import {
  OBJECTIVE_ATTRIBUTE_TYPE,
  OBJECTIVE_STATUS,
} from "src/consts/objectives";

const getObjectiveProgress = (objective) => {
  const attributes = objective?.attributes;
  if (!attributes?.length) {
    return null;
  }

  const statusAttr = attributes?.find(
    (attr) => attr.attributeType === OBJECTIVE_ATTRIBUTE_TYPE.STATUS
  );

  if (statusAttr?.value?.toLowerCase() === OBJECTIVE_STATUS.DONE) {
    return null;
  }

  const progressAttr = attributes.find(
    (attr) =>
      attr.attributeType === OBJECTIVE_ATTRIBUTE_TYPE.PROGRESS_PERCENTAGE
  );

  if (!progressAttr?.value) {
    return null;
  }

  return progressAttr?.value;
};

export default getObjectiveProgress;
